import { CardContent, Grid, Typography } from '@mui/material'
import EDCard from '../../../../../atoms/EDCard/EDCard'
import Toast from '../../../../../atoms/Toast/Toast'
import TableDashboard from '../../../../../view/tableDashboard/TableDashboard'
import ConfirmDeleteDialogV2 from './dialogs/ConfirmDeleteDialogV2'
import CreateEditClassDialogV2 from './dialogs/CreateEditClassDialogV2'
import ListUsersInClassDialog from './dialogs/ListUsersInClassDialog'
import UnitsManagementDialog from './dialogs/UnitsManagementDialog'
import useSchoolClassesV2 from './useSchoolClassesV2'

const SchoolClassesV2 = ({
  classes,
  programs,
  schoolYears,
  educationLevels,
  getSchoolClassesV2,
  onDeleteUserFromClass
}) => {
  const {
    // Data
    columns,
    showToast,
    usersInClass,
    messageToast,
    parsedClasses,
    classUnitsData,
    filteredClasses,
    tableRowOptions,
    isEditClassOpen,
    isUnitsDialogOpen,
    selectedClassToEdit,
    isCreateNewClassOpen,
    selectedClassToDelete,
    selectedClassForUnits,
    isLoadingUsersInClass,
    isConfirmDeleteClassOpen,
    isCreatingOrEditingClass,
    isListOfUsersInClassOpen,
    selectedClassToViewUsers,

    // Actions
    onSearch,
    setShowToast,
    onEditClassV2,
    onDeleteClassV2,
    updateOpenUnits,
    getUsersInClassV2,
    onCreateNewClassV2,
    onCloseUnitsDialog,
    setIsCreateNewClassOpen,
    onCloseDeleteClassDialog,
    onCloseListOfUsersInClass,
    onCloseCreateEditClassDialog
  } = useSchoolClassesV2({
    classes,
    getSchoolClassesV2
  })

  return (
    <Grid item xs={12}>
      <EDCard elevation={0}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant='h4' fontWeight={600}>
                Classes
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TableDashboard
                filters={[]}
                onSearch={onSearch}
                onFilter={() => {}}
                onClickOnCreate={() => {
                  setIsCreateNewClassOpen(true)
                }}
                tableData={parsedClasses}
                onRowClick={getUsersInClassV2}
                tableColumns={columns}
                totalEntries={filteredClasses.length}
                singleEntryLabel={'class'}
                pluralEntryLabel={'classes'}
                isTableDataLoading={false}
                searchInputPlaceholder={'Search class'}
                options={tableRowOptions}
                showPagination={false}
                showTopPagination={false}
                disableFilters
                createButtonLabel='Create class'
              />
            </Grid>
          </Grid>
        </CardContent>
      </EDCard>

      <CreateEditClassDialogV2
        isOpen={selectedClassToEdit ? isEditClassOpen : isCreateNewClassOpen}
        isEditMode={!!selectedClassToEdit}
        classes={classes}
        programs={programs}
        schoolYears={schoolYears}
        educationLevels={educationLevels}
        isLoading={isCreatingOrEditingClass}
        onSubmit={selectedClassToEdit ? onEditClassV2 : onCreateNewClassV2}
        onClose={onCloseCreateEditClassDialog}
        selectedClassToEdit={selectedClassToEdit}
      />

      <ConfirmDeleteDialogV2
        isOpen={isConfirmDeleteClassOpen}
        onClose={onCloseDeleteClassDialog}
        onConfirm={() => {
          onDeleteClassV2(selectedClassToDelete?.guid)
          onCloseDeleteClassDialog()
        }}
      />

      {isListOfUsersInClassOpen && (
        <ListUsersInClassDialog
          selectedClass={selectedClassToViewUsers}
          onClose={onCloseListOfUsersInClass}
          usersInClass={usersInClass}
          isOpen={isListOfUsersInClassOpen}
          isLoading={isLoadingUsersInClass}
          onDeleteUserFromClass={onDeleteUserFromClass}
        />
      )}

      {isUnitsDialogOpen && (
        <UnitsManagementDialog
          isOpen={isUnitsDialogOpen}
          onClose={onCloseUnitsDialog}
          selectedClass={selectedClassForUnits}
          currentOpenUnits={
            classUnitsData[selectedClassForUnits?.guid]?.openUnits || []
          }
          units={selectedClassForUnits?.allUnits || []}
          onSave={updateOpenUnits}
          programGuid={selectedClassForUnits?.programGuid}
        />
      )}

      {showToast && (
        <Toast
          handleShowToast={setShowToast}
          type={messageToast.type}
          text={messageToast.text}
        />
      )}
    </Grid>
  )
}

export default SchoolClassesV2
